import React from 'react';
import { RentalManagerEnvironmentContext } from '../components/RentalManagerEnvironmentProvider';

export const useLogger = () => {
  const { environment } = React.useContext(RentalManagerEnvironmentContext);
  const logger = React.useMemo(() => {
    return environment.logger;
  }, [environment.logger]);

  return logger;
};
